<template>
  <div class="asc-custom-alerts-alert-template">
    <template v-if="!isCustomAlertsActive">
      <asc-page-coming-soon
        label="Custom Alerts page Coming Soon!"
      ></asc-page-coming-soon>
    </template>
    <template v-if="isCustomAlertsActive && !checkSimpleAlert">
      <v-row>
        <v-col :cols="getColumnSize">
          <asc-advanced-custom-alerts-configuration-wrapper
            :alert-data="alertData"
            :airline="airline"
            :platform="platform"
            :report-type="reportType"
            :alert-type="alertType"
            :parameter-tail-list="parameterTailList"
            :ata-chapter-list="ataChapterList"
            :tails="tails"
            :airline-id="airlineId"
            :is-ata-error-displayed="isAtaErrorDisplayed"
            :is-data-bricks-running="isDataBricksRunning"
            :tooltip-msg="tooltipMsg"
            :is-read-only="isReadOnly"
            @isDirty="handleChangeIsDirty"
            @handleUpdateAlertName="handleUpdateAlertName"
            @onUpdateAlertDescription="handleUpdateAlertDescription"
            @handleChangePersistenceFrom="handleChangePersistenceFrom"
            @handleChangePersistenceTo="handleChangePersistenceTo"
            @handleChangeTails="handleChangeTails"
            @handleChangeAtaChapters="handleChangeAtaChapters"
            @invalidPersistence="handleInvalidPersistence"
            @validPersistence="handleValidPersistence"
            @handleChangeSeverityLevel="handleChangeSeverityLevel"
            @handleChangeAggregateDays="handleChangeAggregateDays"
            @handleChangeAggregateReports="handleChangeAggregateReports"
            @handleChangeConfigurationType="handleChangeConfigurationType"
          />
        </v-col>
        <v-col v-if="!isAdvancedDplf" :cols="4">
          <asc-custom-analytics-performance-wrapper
            :performance-data="getPerformanceData"
            :performance-set-date="getPerformanceSetDate"
            :reset-performance-values="getResetPerformanceValues"
            :alert-active="getIsActive"
            :is-data-bricks-running="isDataBricksRunning"
            :tooltip-msg="tooltipMsg"
            :is-read-only="isReadOnly"
            @isDirty="handleChangeIsDirty"
            @handleChangeResetPerformanceValues="
              handleChangeResetPerformanceValues
            "
          ></asc-custom-analytics-performance-wrapper>
        </v-col>
      </v-row>
      <div class="asc-custom-alert-bg-color">
        <div>
          <div style="padding: 15px 15px 15px 15px">
            <asc-header uppercase size="h3" value="Analytic Logic Builder">
            </asc-header>
          </div>
          <asc-divider />
        </div>
        <asc-container style="margin-bottom: 20px' margin-top:10px">
          <asc-advanced-custom-alerts-expression-input-wrapper
            :airline="airline"
            :alert-data="alertData"
            :configuration-option="selectedConfigurationValue"
            :expression-input="expression"
            :pdf-document="pdfGuide"
            :logic-string-valid="logicStringValid"
            :validate-loading="validateLoading"
            :alert-type="alertType"
            :message-codes="messageCodes"
            :parameter-list="parameterList"
            :parameter-tail-list="parameterTailList"
            :part-numbers="partNumbers"
            :flight-phase-list="flightPhases"
            :advanced-function-list="advancedFunctionList"
            :allowed-characters="allowedCharacters"
            :expression-options="expressionOptions"
            :is-advanced-full-flight="isAdvancedFullFlight"
            :is-advanced-dplf="isAdvancedDplf"
            :show-logic-validation-error-message="
              showLogicValidationErrorMessage
            "
            :logic-string-validation-error-text="logicStringValidationErrorText"
            :airlines-tier-type="airlinesTierType"
            :is-look-back-valid="isLookBackValid"
            :enable-run-performance-estimate="enableRunPerformanceEstimate"
            :enable-validate-button="enableValidateButton"
            :is-data-bricks-running="isDataBricksRunning"
            :estimate-button-name="estimateButtonName"
            :look-back-response="lookBackResponse"
            :tooltip-msg="tooltipMsg"
            :run-limit="runLimit"
            :display-run-performance-section="displayRunPerformanceSection"
            :is-read-only="isReadOnly"
            @handleChangePersistenceFrom="handleChangePersistenceFrom"
            @handleChangePersistenceTo="handleChangePersistenceTo"
            @invalidPersistence="handleInvalidPersistence"
            @validPersistence="handleValidPersistence"
            @handleChangeTails="handleChangeTails"
            @handleTextUpdated="handleTextUpdated"
            @handleLogicValidate="handleLogicValidate"
            @isSaveDisabled="handleChangeSaveDisabled"
            @isDirty="handleChangeIsDirty"
            @handleChangePartNumbers="handleChangePartNumbers"
            @handleChangeAggregateDays="handleChangeAggregateDays"
            @handleChangeAggregateReports="handleChangeAggregateReports"
            @handleChangeConfigurationType="handleChangeConfigurationType"
            @onPerformanceAnanlysis="handlePerformanceAnanlysis"
            @onCancelPerformanceAnalysis="handleCancelPerformanceAnalysis"
            @onSeeEstimateDash="handleSeeEstimateDash"
            @onDatabricksErrorNotificationClose="
              handleDatabricksErrorNotificationClose
            "
          ></asc-advanced-custom-alerts-expression-input-wrapper>
        </asc-container>
      </div>
      <div
        v-if="
          alertType === 'advanced-fullflight' || alertType === 'advanced-acmf'
        "
        class="asc-custom-alert-bg-color"
      >
        <div>
          <div style="padding: 15px 15px 15px 15px">
            <asc-header uppercase size="h3" value="Recommended Action">
            </asc-header>
          </div>
          <asc-divider />
        </div>
        <asc-container style="margin-top: 10px">
          <asc-advanced-custom-alerts-rec-action-wrapper
            :alert-data="alertData"
            :is-valid-rec-action="isValidRecAction"
            :is-data-bricks-running="isDataBricksRunning"
            :tooltip-msg="tooltipMsg"
            :is-read-only="isReadOnly"
            @handleChangeRecAction="handleChangeRecAction"
            @isDirty="handleChangeIsDirty"
          ></asc-advanced-custom-alerts-rec-action-wrapper>
        </asc-container>
      </div>
      <div
        v-if="
          alertType === 'advanced-fullflight' || alertType === 'advanced-acmf'
        "
        class="asc-custom-alert-bg-color"
      >
        <div>
          <div style="padding: 15px 15px 15px 15px">
            <asc-header
              uppercase
              size="h3"
              value="Who can see when this analytic triggers an alert?"
            >
            </asc-header>
          </div>
          <asc-divider />
        </div>
        <asc-container style="margin-bottom: 20px' margin-top:10px">
          <asc-advanced-custom-alerts-is-shared-wrapper
            :alert-data="alertData"
            :airline="airline"
            :is-shared-disabled="isSharedDisabled"
            :tooltip-msg="tooltipMsg"
            :is-data-bricks-running="isDataBricksRunning"
            :is-read-only="isReadOnly"
            @isShared="handleChangeIsShared"
          ></asc-advanced-custom-alerts-is-shared-wrapper>
        </asc-container>
      </div>
    </template>
    <template v-if="isCustomAlertsActive && checkSimpleAlert">
      <asc-container>
        <asc-custom-alerts-configuration-wrapper
          :alert-data="alertData"
          :show-configuration="showConfiguration"
          :show-add-parameter="showAddParameter"
          :show-histogram="getShowHistogram"
          :alert-type="alertType"
          :activate-enabled="getActivateEnabled"
          :tails="tails"
          :flight-phases="flightPhases"
          :parameter-tail-list="parameterTailList"
          @handleAddParameter="handleAddParameter"
          @handleRemoveParameter="handleRemoveParameter"
          @showHistogram="handleShowHistogram"
          @handleChangePersistenceFrom="handleChangePersistenceFrom"
          @handleChangePersistenceTo="handleChangePersistenceTo"
          @handleChangeTails="handleChangeTails"
          @handleUpdateFlightPhase="handleUpdateFlightPhase"
          @handleChangeFlightPhase="handleChangeFlightPhase"
          @clearHistogramData="handleClearHistogramData"
          @handleUpdateAlertName="handleUpdateAlertName"
          @handleDuplicateAlert="handleDuplicateAlert"
          @invalidPersistence="handleInvalidPersistence"
          @validPersistence="handleValidPersistence"
        ></asc-custom-alerts-configuration-wrapper>
        <asc-custom-alerts-histogram-wrapper
          v-if="getShowHistogram"
          :alert-type="alertType"
          :airline-name="selectedAirlineName"
          :loading="isHistogramDataLoading"
          :unit-name="histogramUnitName"
          :parameter-name="parameterName"
          :data="alertData.histogramData"
          :x-axis-ticks="histogramXAxisTicks"
          :is-range-min-enabled="alertData.isRangeMinEnabled"
          :is-range-max-enabled="alertData.isRangeMaxEnabled"
          :is-low-warning-enabled="alertData.isLowWarningEnabled"
          :is-high-warning-enabled="alertData.isHighWarningEnabled"
          :is-low-caution-enabled="alertData.isLowCautionEnabled"
          :is-high-caution-enabled="alertData.isHighCautionEnabled"
          :min-range="alertData.minRange"
          :max-range="alertData.maxRange"
          :low-warning="alertData.lowWarning"
          :low-caution="alertData.lowCaution"
          :high-caution="alertData.highCaution"
          :high-warning="alertData.highWarning"
          :is-threshold-alert-active="isThresholdAlertActive"
          @updateThresholdAlertStatus="handleUpdateThresholdAlertStatus"
          @updateMinRange="handleUpdateMinRange"
          @updateMaxRange="handleUpdateMaxRange"
          @updateLowWarning="handleUpdateLowWarning"
          @updateLowCaution="handleUpdateLowCaution"
          @updateHighCaution="handleUpdateHighCaution"
          @updateHighWarning="handleUpdateHighWarning"
          @invalidThreshold="handleInvalidThreshold"
          @validThreshold="handleValidThreshold"
        >
        </asc-custom-alerts-histogram-wrapper>
      </asc-container>
    </template>
  </div>
</template>

<script>
import AscAdvancedCustomAlertsConfigurationWrapper from '../organisms/AscAdvancedCustomAlertsConfigurationWrapper.vue'
import AscAdvancedCustomAlertsExpressionInputWrapper from '../organisms/AscAdvancedCustomAlertsExpressionInputWrapper.vue'
import AscAdvancedCustomAlertsRecActionWrapper from '../organisms/AscAdvancedCustomAlertsRecActionWrapper.vue'
import AscAdvancedCustomAlertsIsSharedWrapper from '../organisms/AscAdvancedCustomAlertsIsSharedWrapper.vue'
import AscPageComingSoon from '../molecules/AscPageComingSoon.vue'
import AscCustomAlertsConfigurationWrapper from '../organisms/AscCustomAlertsConfigurationWrapper.vue'
import AscCustomAlertsHistogramWrapper from '../organisms/AscCustomAlertsHistogramWrapper.vue'
import AscCustomAlertMixin from '../mixins/AscCustomAlertMixin.vue'
import AscHeader from '@/components/atoms/AscHeader'
import AppFeatureFlags from '@/utilities/appFeatureFlags'
import { isValidRecAction } from '@/utilities/customAlerts'
import AscContainer from '../atoms/AscContainer.vue'
import AscDivider from '@/components/atoms/AscDivider'
import AscCustomAnalyticsPerformanceWrapper from '../organisms/AscCustomAnalyticsPerformanceWrapper.vue'

export default {
  name: 'AscCustomAlertsAlertTemplate',

  components: {
    AscAdvancedCustomAlertsConfigurationWrapper,
    AscPageComingSoon,
    AscCustomAlertsConfigurationWrapper,
    AscCustomAlertsHistogramWrapper,
    AscAdvancedCustomAlertsExpressionInputWrapper,
    AscAdvancedCustomAlertsRecActionWrapper,
    AscAdvancedCustomAlertsIsSharedWrapper,
    AscContainer,
    AscHeader,
    AscDivider,
    AscCustomAnalyticsPerformanceWrapper,
  },

  mixins: [AscCustomAlertMixin],

  props: {
    displayRunPerformanceSection: {
      type: Boolean,
      default: false,
    },
    tooltipMsg: {
      type: String,
      default: '',
    },
    lookBackResponse: {
      type: Object,
      default: () => {},
    },
    estimateButtonName: {
      type: String,
      default: '',
    },
    enableValidateButton: {
      type: Boolean,
      default: true,
    },
    enableRunPerformanceEstimate: {
      type: Boolean,
      default: false,
    },
    isDataBricksRunning: {
      type: Boolean,
      default: false,
    },
    alertType: {
      type: String,
      default: '',
    },
    tails: {
      type: Array,
      default: () => [],
    },
    activateEnabled: {
      type: Boolean,
    },
    isSharedDisabled: {
      type: Boolean,
      default: false,
    },
    flightPhases: {
      type: Array,
      default: () => [],
    },
    showConfiguration: {
      type: Boolean,
      default: false,
    },
    showAddParameter: {
      type: Boolean,
      default: true,
    },
    alertData: {
      type: Object,
      default: () => {},
    },
    histogramUnitName: {
      type: String,
      default: '',
    },
    histogramXAxisTicks: {
      type: Array,
      default: () => [],
    },
    userAirlines: {
      type: Array,
      default: () => [],
    },
    parameterTailList: {
      type: Array,
      default: () => [],
    },
    ataChapterList: {
      type: Array,
      default: () => [],
    },
    messageCodes: {
      type: Array,
      default: () => [],
    },
    parameterList: {
      type: Array,
      default: () => [],
    },
    advancedFunctionList: {
      type: Array,
      default: () => [],
    },
    partNumbers: {
      type: Array,
      default: () => [],
    },
    saveLoading: {
      type: Boolean,
    },
    isHistogramDataLoading: {
      type: Boolean,
      default: true,
    },
    selectedAirlineName: {
      type: String,
      default: '',
    },
    parameterName: {
      type: String,
      default: '',
    },
    fullFlightActiveCount: {
      type: Number,
      default: 0,
    },
    airline: {
      type: String,
      default: '',
    },
    platform: {
      type: String,
      default: '',
    },
    reportType: {
      type: String,
      default: '',
    },
    airlineId: {
      type: Number,
      default: 0,
    },
    pdfGuide: {
      type: Blob,
      default: new Blob(),
    },
    expression: {
      type: String,
      default: '',
    },
    logicStringValid: {
      type: Boolean,
      default: true,
    },
    validateLoading: {
      type: Boolean,
      default: false,
    },
    allowedCharacters: {
      type: Object,
      default: () => {},
    },
    expressionOptions: {
      type: Array,
      default: () => [],
    },
    isAdvancedFullFlight: {
      type: Boolean,
      default: false,
    },
    isAdvancedDplf: {
      type: Boolean,
      default: false,
    },
    airlinesTierType: {
      type: Number,
      default: 0,
    },
    performanceData: {
      type: Object,
      default: () => {},
    },
    performanceSetDate: {
      type: String,
      default: '',
    },
    resetPerformanceValues: {
      type: Boolean,
      default: false,
    },
    isThresholdAlertActive: {
      type: Boolean,
    },
    isValidRecAction: {
      type: Boolean,
    },
    showLogicValidationErrorMessage: {
      type: Boolean,
      default: false,
    },
    logicStringValidationErrorText: {
      type: String,
      default: '',
    },
    isAtaErrorDisplayed: {
      type: Boolean,
      default: false,
    },
    isLookBackValid: {
      type: Boolean,
      default: null,
    },
    runLimit: {
      type: Number,
      default: 0,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showHistogram: false,
      persistenceFromSet: null,
      persistenceToSet: null,
      aggregateDaysSet: null,
      aggregateReportsSet: null,
      persistenceValid: true,
      thresholdsValid: true,
      tailSet: null,
      flightPhaseSet: null,
      lowWarningActive: null,
      lowCautionActive: null,
      highWarningActive: null,
      highCautionActive: null,
      lowWarningValid: true,
      lowCautionValid: true,
      highWarningValid: true,
      highCautionValid: true,
    }
  },

  computed: {
    getColumnSize() {
      return !this.isAdvancedDplf ? 8 : ''
    },
    selectedConfigurationValue() {
      return this.alertData?.configurationType
    },
    checkSimpleAlert() {
      if (this.alertType === 'acmf' || this.alertType === 'fullflight')
        return true
      else return false
    },
    getShowHistogram() {
      if (this.showConfiguration && this.showHistogram) {
        return true
      } else {
        return false
      }
    },
    isCustomAlertsActive() {
      return AppFeatureFlags.getCustomAlertsPage()
    },
    getIsActive() {
      return this.alertData.isEnabled
    },
    getActivateEnabled() {
      return this.activateEnabled
    },

    checkForThresholdsActive() {
      if (this.alertData.isLowWarningEnabled && this.lowWarningValid) {
        return true
      }
      if (this.alertData.isLowCautionEnabled && this.lowCautionValid) {
        return true
      }
      if (this.alertData.isHighWarningEnabled && this.highWarningValid) {
        return true
      }
      if (this.alertData.isHighCautionEnabled && this.highCautionValid) {
        return true
      }

      return false
    },

    getPerformanceData() {
      return { ...this.alertData.performanceResult }
    },
    getPerformanceSetDate() {
      return this.alertData.performanceSetDate
    },
    getResetPerformanceValues() {
      return this.alertData.resetPerformanceValues
    },
  },

  watch: {
    alertData: {
      deep: true,
      async handler() {
        this.persistenceFromSet = this.alertData?.persistenceFrom !== null
        this.persistenceToSet = this.alertData?.persistenceTo !== null
        this.tailSet = this.alertData?.tails
          ? this.alertData.tails.length > 0
          : false
        if (this.alertType === 'fullflight') {
          this.flightPhaseSet =
            this.alertData.flightPhase && this.alertData.flightPhase.length > 0
        } else {
          this.flightPhaseSet = null
        }
        this.lowWarningActive = this.alertData?.isLowWarningEnabled
        this.lowCautionActive = this.alertData?.isLowCautionEnabled
        this.highWarningActive = this.alertData?.isHighWarningEnabled
        this.highCautionActive = this.alertData?.isHighCautionEnabled
      },
    },
    activateEnabled(newValue) {
      this.$emit('handleChangeActivateEnabled', newValue)
    },
    parameterName(val) {
      if (val !== '' && !this.hasSaved) {
        this.$emit('isSaveDisabled', false)
      }
    },
  },

  created() {
    // if you're retrieving a saved alert
    // show the whole screen
    if (this.alertData.id !== null) {
      this.showHistogram = true
      this.hasSaved = true
      this.$emit('isSaveDisabled', true)
    }
  },

  methods: {
    handleDatabricksErrorNotificationClose() {
      this.$emit('onDatabricksErrorNotificationClose')
    },
    handleUpdateThresholdAlertStatus(value) {
      this.$emit('updateThresholdAlertStatus', value)
    },
    handleChangeIsDirty() {
      this.$emit('isDirty')
    },
    handleInvalidPersistence() {
      this.persistenceValid = false
      if (this.getIsActive) {
        this.$emit('handleToggleActivate', false)
        this.handleSaveAlert()
      }
    },
    handleValidPersistence() {
      this.persistenceValid = true
    },
    handleInvalidThreshold() {
      this.thresholdsValid = false
      if (this.getIsActive) {
        this.$emit('handleToggleActivate', false)
        this.handleSaveAlert()
      }
    },
    handleValidThreshold() {
      this.thresholdsValid = true
    },
    handleCancelAlert() {
      this.$emit('handleCancelAlert')
    },
    handleUpdateAlertName(value) {
      this.$emit('isSaveDisabled', false)
      this.$emit('handleUpdateAlertName', value)
    },
    handleUpdateAlertDescription(value) {
      this.$emit('isSaveDisabled', false)
      this.$emit('onUpdateAlertDescription', value)
    },
    handleOpenAlertTypeDialog() {
      this.$emit('openAlertTypeDialog')
    },
    handleAddParameter() {
      this.$emit('handleAddParameter')
    },
    handleChangePersistenceFrom(value) {
      this.$emit('isSaveDisabled', false)
      this.persistenceFromSet = true
      this.$emit('handleChangePersistenceFrom', value)
    },
    handleChangePersistenceTo(value) {
      this.persistenceToSet = true
      this.$emit('isSaveDisabled', false)
      this.$emit('handleChangePersistenceTo', value)
    },
    handleChangeAggregateDays(value) {
      this.aggregateDaysSet = true
      this.$emit('isSaveDisabled', false)
      this.$emit('handleChangeAggregateDays', value)
    },
    handleChangeAggregateReports(value) {
      this.aggregateReportsSet = true
      this.$emit('isSaveDisabled', false)
      this.$emit('handleChangeAggregateReports', value)
    },
    handleChangeConfigurationType(value) {
      this.$emit('isSaveDisabled', false)
      this.$emit('handleChangeConfigurationType', value)
    },
    handleChangeSeverityLevel(value) {
      this.$emit('isSaveDisabled', false)
      this.$emit('handleChangeSeverityLevel', value)
    },
    handleChangeTails(value) {
      this.tailSet = value.length > 0
      if (
        this.$options.propsData.alertData.tails &&
        this.$options.propsData.alertData.tails.length !== value.length
      )
        this.$emit('isSaveDisabled', false)
      this.$emit('handleChangeTails', value)
      if (this.getIsActive && value.length === 0) {
        this.$emit('isSaveDisabled', true)
        this.$emit('handleToggleActivate', false)
      }
    },
    handleChangePartNumbers(value) {
      if (
        (this.$options.propsData.alertData.partNumbers &&
          this.$options.propsData.alertData.partNumbers.length !==
            value.length) ||
        // eslint-disable-next-line no-prototype-builtins
        (!this.$options.propsData.alertData.hasOwnProperty('partNumbers') &&
          value.length > 0)
      )
        this.$emit('isSaveDisabled', false)
      this.$emit('handleChangePartNumbers', value)
    },
    handleChangeAtaChapters(value) {
      this.$emit('handleChangeAtaChapters', value)
      if (this.getIsActive && value.length === 0) {
        this.$emit('handleToggleActivate', false)
      } else {
        this.$emit('isSaveDisabled', false)
      }
    },

    handleChangeRecAction(value) {
      this.$emit('handleChangeRecAction', value)
      if (this.getIsActive && !isValidRecAction(value)) {
        this.$emit('handleToggleActivate', false)
      } else {
        this.$emit('isSaveDisabled', false)
      }
    },
    handleChangeIsShared(value) {
      this.$emit('isShared', value)
      this.$emit('isSaveDisabled', false)
    },
    handleUpdateFlightPhase(value) {
      this.flightPhaseSet = value.length > 0
      this.$emit('isSaveDisabled', false)
      this.$emit('handleUpdateFlightPhase', value)
    },
    handleChangeFlightPhase(value) {
      this.$emit('handleChangeFlightPhase', value)
    },
    handleShowHistogram() {
      this.showHistogram = true
    },
    handleClearHistogramData() {
      this.$emit('handleClearHistogramData')
      this.$emit('handleChangeActivateEnabled', false)
      if (this.getIsActive) {
        this.$emit('handleToggleActivate', false)
      }
    },
    handleRemoveParameter() {
      this.$emit('isSaveDisabled', false)
      this.showHistogram = false
      this.persistenceFromSet = false
      this.persistenceToSet = false
      this.persistenceValid = true
      this.tailSet = false
      this.flightPhaseSet = false
      this.lowWarningActive = false
      this.lowCautionActive = false
      this.highWarningActive = false
      this.highCautionActive = false
      this.$emit('handleRemoveParameter')
    },
    handleUpdateHighCaution(value) {
      this.$emit('isSaveDisabled', false)
      this.highCautionActive = !isNaN(value.value) && value.active
      this.highCautionValid = value.valid
      this.$emit('handleUpdateHighCaution', value)
      if (!value.valid) {
        this.thresholdsValid = false
        this.handleInvalidThreshold()
      } else {
        this.thresholdsValid = true
      }
    },
    handleUpdateLowCaution(value) {
      this.$emit('isSaveDisabled', false)
      this.lowCautionActive = !isNaN(value.value) && value.active
      this.lowCautionValid = value.valid
      this.$emit('handleUpdateLowCaution', value)
      if (!value.valid) {
        this.thresholdsValid = false
        this.handleInvalidThreshold()
      } else {
        this.thresholdsValid = true
      }
    },
    handleUpdateLowWarning(value) {
      this.$emit('isSaveDisabled', false)
      this.lowWarningActive = !isNaN(value.value) && value.active
      this.lowWarningValid = value.valid
      this.$emit('handleUpdateLowWarning', value)
      if (!value.valid) {
        this.thresholdsValid = false
        this.handleInvalidThreshold()
      } else {
        this.thresholdsValid = true
      }
    },
    handleUpdateHighWarning(value) {
      this.$emit('isSaveDisabled', false)
      this.highWarningActive = !isNaN(value.value) && value.active
      this.highWarningValid = value.valid
      this.$emit('handleUpdateHighWarning', value)
      if (!value.valid) {
        this.thresholdsValid = false
        this.handleInvalidThreshold()
      } else {
        this.thresholdsValid = true
      }
    },
    handleUpdateMinRange(value) {
      this.$emit('isSaveDisabled', false)
      this.$emit('handleUpdateMinRange', value)
      if (!value.valid) {
        this.thresholdsValid = false
        this.handleInvalidThreshold()
      } else {
        this.thresholdsValid = true
      }
    },
    handleUpdateMaxRange(value) {
      this.$emit('isSaveDisabled', false)
      this.$emit('handleUpdateMaxRange', value)
      if (!value.valid) {
        this.thresholdsValid = false
        this.handleInvalidThreshold()
      } else {
        this.thresholdsValid = true
      }
    },
    handleDuplicateAlert() {
      this.$emit('isSaveDisabled', false)
      this.$emit('handleDuplicateAlert')
    },
    handleTextUpdated(value) {
      this.$emit('handleTextUpdated', value)
    },
    handleLogicValidate(value) {
      this.$emit('handleLogicValidate', value)
    },
    handleChangeSaveDisabled(value) {
      this.$emit('isSaveDisabled', value)
    },
    handleChangeResetPerformanceValues(value) {
      this.$emit('isSaveDisabled', false)
      this.$emit('handleChangeResetPerformanceValues', value)
    },
    handlePerformanceAnanlysis(date) {
      this.$emit('onPerformanceAnanlysis', date)
    },
    handleCancelPerformanceAnalysis() {
      this.$emit('onCancelPerformanceAnalysis')
    },
    handleSeeEstimateDash() {
      this.$emit('onSeeEstimateDash')
    },
  },
}
</script>

<style lang="scss">
.asc-custom-alerts-template {
  background-color: $gray-100;
  position: relative;
}
.asc-custom-alert-bg-color {
  background-color: $primary-white;
  margin-top: 20px;
}
</style>
